import { getIn } from 'icepick';
import { defaultMemoize } from 'reselect';

const EmptyImmutableObject = Object.freeze({});
const EmptyImmutableArray = Object.freeze([]);

/**
 * gets the air request snapshot
 * @param {*} state
 */
export function getAirRequestSnapshot(state) {
  return getIn(state, ['eventTravel', 'airData', 'airRequestSetup']) || EmptyImmutableObject;
}

/**
 * gets reg rules of hotel from the travel snapshot in state
 * @param {*} state
 */
export function getHotelRegRules(state) {
  return getIn(state, ['eventTravel', 'hotelsData', 'hotelRequestRules']) || EmptyImmutableArray;
}

/**
 * Whether cvent hotel request is enabled or not
 * @param {*} eventTravel
 */
export const isHotelRequestEnabled = (eventTravel) => getIn(eventTravel, ['hotelsData', 'isHotelRequestEnabled']) || false;

/**
 * Whether passkey hotel request is enabled or not
 * @param {*} eventTravel
 */
export const isPasskeyEnabled = (eventTravel) => getIn(eventTravel, ['hotelsData', 'isPasskeyEnabled']) || false;

/**
 * Whether we should automatically redirect an invitee to Concur or not
 */
export const shouldAutoRedirectToConcur = (eventTravel) => {
  const { airData: { isConcurEnabled, concurSetup: { isRedirectionAllowed } = {} } } = eventTravel;
  return isConcurEnabled && isRedirectionAllowed;
};

export const getGroupFlightsSnapshotData = defaultMemoize((eventTravel) => {
  const { airData: { isGroupFlightEnabled, groupFlightSetup = {} } = {} } = eventTravel;
  return {
    isGroupFlightEnabled,
    groupFlightSetup
  };
});

/**
 * gets the applicable passkey attendee mappings, setup by planner
 * @param state
 * @returns {*|{}}
 */
export const getApplicablePasskeyAttendeeTypeMappings = (state) => {
  const passkeySetup = getIn(state, ['eventTravel', 'hotelsData', 'passkeySetup']);
  const attendeeTypeMappingBy = getIn(passkeySetup, ['attendeeTypeMappingBy']);
  const attendeeTypeMappings = getIn(passkeySetup, ['attendeeTypeMappings']) || EmptyImmutableObject;
  return attendeeTypeMappings[attendeeTypeMappingBy];
};
